import { useEffect, useState } from "react";
import { Sparkles, X, Clock } from "lucide-react";
import { waLink } from "../../lib/site";

function textColorFor(hex) {
  const h = (hex || "#D6FF00").replace("#", "");
  if (h.length < 6) return "#060806";
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "#060806" : "#FFFFFF";
}

function useCountdown(endsAt, onExpire) {
  const [label, setLabel] = useState("");
  useEffect(() => {
    if (!endsAt) return;
    const end = new Date(endsAt).getTime();
    if (isNaN(end)) return;
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) { setLabel(""); onExpire?.(); return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setLabel(d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${s}s`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [endsAt, onExpire]);
  return label;
}

export default function OfferBanner({ text, endsAt, color = "#D6FF00", onClose, onExpire }) {
  const countdown = useCountdown(endsAt, onExpire);
  const fg = textColorFor(color);
  return (
    <div
      className="fixed left-0 top-0 z-[60] flex h-10 w-full items-center justify-center gap-3 px-10"
      style={{ backgroundColor: color, color: fg }}
      data-testid="offer-banner"
      role="region"
      aria-label="Promotional offer"
    >
      <a href={waLink(`Hi! I'd like to know more about this offer: ${text}`)} target="_blank" rel="noreferrer" className="flex items-center gap-2 truncate text-xs font-bold uppercase tracking-wide hover:underline sm:text-sm">
        <Sparkles size={15} className="shrink-0" />
        <span className="truncate">{text}</span>
      </a>
      {countdown && (
        <span className="hidden shrink-0 items-center gap-1.5 pl-3 text-xs font-bold uppercase tracking-wide sm:flex" style={{ borderLeft: `1px solid ${fg}40` }} data-testid="offer-countdown">
          <Clock size={13} /> Ends in {countdown}
        </span>
      )}
      <button onClick={onClose} data-testid="offer-dismiss" aria-label="Dismiss offer" className="absolute right-3 flex h-6 w-6 items-center justify-center opacity-80 hover:opacity-100">
        <X size={15} />
      </button>
    </div>
  );
}
